import * as dayjs from 'dayjs';
import { Franchise } from '../api';
import { DateService } from '../services/date.service';

export const INITIAL_FRANCHISE = Franchise.Adult2500;
export const INITIAL_ACCIDENT_COVERAGE = false;

export function hasDefaultAccidentCoverage(dateOfBirth: string, saleOfferBegin: string): boolean {
  const ageAtOfferBegin = dayjs(saleOfferBegin).diff(dateOfBirth, 'years');
  return ageAtOfferBegin < 16 || ageAtOfferBegin >= 65;
}

export function getDefaultFranchise(dateOfBirth: string, saleOfferBegin: string): Franchise {
  if (dateOfBirth === '') {
    return INITIAL_FRANCHISE;
  }
  return DateService.needsAdultFranchise(dateOfBirth, saleOfferBegin) ? INITIAL_FRANCHISE : 'CHILD_0';
}
